import React from "react";
import { SanityVideo } from "../../types/graphql-types";
import { isNullOrWhiteSpace } from "../utilities/string";
import { Video } from "./Video";

interface VideoBlockProps {
  video: Omit<SanityVideo, "_key" | "_type"> | undefined | null;
}

export const VideoBlock: React.FC<VideoBlockProps> = ({ video }) => {
  if (!video || isNullOrWhiteSpace(video.videoId)) {
    return null;
  }

  return (
    <Video
      url={`https://fast.wistia.net/embed/iframe/${video.videoId}`}
      title={video.videoText ?? ""}
    />
  );
};
